import React, { FC, useState, useRef, InputHTMLAttributes } from 'react';
import PlanCard from '../PlanCard/new';
import { Product, SelectedProductsState, Feature, Modals, PlanCardsMetadata } from '~/types/products';
import { Buttons, Card } from '../../types/preamp';
import { Preamp } from '@red-digital/bricks';
import { ReactSelectOption } from '~/types/common';

interface Props {
  metadata?: PlanCardsMetadata;
  activeProducts: Product[];
  addPhoneState: boolean;
  bundleCost: number;
  bundleFeatures: Feature[];
  carousel: {
    direction: number;
    productIndex: number;
    paginate: (index: number) => void;
  };
  sweetener: {
    label: string;
    value: string;
  };
  singleProduct: boolean;
  isCopper: boolean;
  is200: boolean;
  is500: boolean;
  is1Gig: boolean;
  is2Gig: boolean;
  is5Gig: boolean;
  is7Gig: boolean;
  handleSelectPlan?: (plan: Product) => void;
  setActiveModal: (key: Modals) => void;
  setEeroModal: (product: Product) => void;
  setVasModal: (product: Product) => void;
  setBroadbandConsumerLabelModal: (product: Product) => void;
  selectedState?: SelectedProductsState;
  isCopper2Fiber: boolean;
  buttons?: Buttons;
  card?: Card;
  recommended?: string;
  productFilters?: {
    options: ReactSelectOption[];
    setOptions: (options: ReactSelectOption[]) => void;
    sweetener: ReactSelectOption;
    setSweetener: (selected: ReactSelectOption) => void;
    voiceAvailable: boolean;
    handleAddHomePhone: (event: InputHTMLAttributes<HTMLInputElement>) => void;
    handleAddProductState: (product: Product) => void;
    addPhoneState: boolean;
  };
  showPlanCardBanner: boolean;
}

const QuizPlanCards: FC<Props> = ({
  activeProducts,
  addPhoneState,
  bundleCost,
  bundleFeatures,
  singleProduct,
  sweetener,
  setActiveModal,
  setEeroModal,
  setVasModal,
  setBroadbandConsumerLabelModal,
  isCopper,
  is200,
  is500,
  is1Gig,
  is2Gig,
  is5Gig,
  is7Gig,
  isCopper2Fiber,
  buttons,
  card,
  handleSelectPlan,
  selectedState,
  recommended,
  productFilters,
  showPlanCardBanner,
}) => {
  const [selectedCardIndex, setSelectedCardIndex] = useState(null);

  const cardTracking = {
    location: 'gdt_plan_cards',
    position: "GDT Plan Cards"
  }

  /* Equal Height for PlanCard
  ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
  const [maxLegalHeight, setMaxLegalHeight] = useState(0);
  const maxLegalHeightRef = useRef<number[]>([]);

  const [maxFeatureCollapsedHeight, setMaxFeatureCollapsedHeight] = useState(0);
  const maxFeatureCollapsedHeightRef = useRef<number[]>([]);
  const [maxFeatureExpandedHeight, setMaxFeatureExpandedHeight] = useState(0);
  const maxFeatureExpandedHeightRef = useRef<number[]>([]);

  return (
    <Preamp placement="4xPj6N8UVVzt18dXyTpo8j">
      {(metadata) => {
        return (
          <div className="plan-packages__cards w-theme quiz-layout" data-testid="plan-packages-cards">
            {activeProducts.length > 0 &&
              activeProducts
                .filter((product) => product.productId !== recommended) // remove recommended product for quiz results
                .map((product, index) => {
                  return (
                    <PlanCard
                      index={index}
                      metadata={metadata || {}}
                      card={card}
                      selectedCard={selectedCardIndex === index}
                      setSelectedCardIndex={setSelectedCardIndex}
                      addPhoneState={addPhoneState}
                      key={product.productId}
                      selectedState={selectedState}
                      singleProduct={singleProduct}
                      sweetener={sweetener}
                      product={product}
                      setActiveModal={setActiveModal}
                      bundleCost={bundleCost}
                      bundleFeatures={bundleFeatures}
                      setEeroModal={setEeroModal}
                      setVasModal={setVasModal}
                      setBroadbandConsumerLabelModal={setBroadbandConsumerLabelModal}
                      isCopper={isCopper}
                      is200={is200}
                      is500={is500}
                      is1Gig={is1Gig}
                      is2Gig={is2Gig}
                      is5Gig={is5Gig}
                      is7Gig={is7Gig}
                      isCopper2Fiber={isCopper2Fiber}
                      buttons={buttons}
                      handleSelectPlan={handleSelectPlan}
                      maxLegalHeight={maxLegalHeight}
                      maxLegalHeightRef={maxLegalHeightRef}
                      setMaxLegalHeight={setMaxLegalHeight}
                      maxFeatureCollapsedHeight={maxFeatureCollapsedHeight}
                      maxFeatureCollapsedHeightRef={maxFeatureCollapsedHeightRef}
                      setMaxFeatureCollapsedHeight={setMaxFeatureCollapsedHeight}
                      maxFeatureExpandedHeight={maxFeatureExpandedHeight}
                      maxFeatureExpandedHeightRef={maxFeatureExpandedHeightRef}
                      setMaxFeatureExpandedHeight={setMaxFeatureExpandedHeight}
                      productFilters={productFilters}
                      cardTracking={cardTracking}
                      showPlanCardBanner={showPlanCardBanner}
                    />
                  );
                })}
          </div>
        );
      }}
    </Preamp>
  );
};

QuizPlanCards.displayName = 'QuizPlanCards';

export default QuizPlanCards;
